import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useTrackClickEvents } from '@carvana/vdp-react-hooks';
import { useContext, useEffect } from 'react';
import {
  useLogZipCodeChanges,
  useNavigation,
  useScrollToTop,
  useSetCvnaId,
  useSetPageNumber,
  useShowFinance,
  useToggleAppliedTradeCookie
} from '@/Search/hooks';
import {
  useGetAvailability,
  useGetInventory,
  useGetPricing,
  useGetUserProfile
} from '~/hooks/services';
import { useGetLowInventoryAvailability } from '~/hooks/services/useGetAvailability';
import useResizeListener from '~/hooks/useResizeListener';
import useSendDDExperiments from '~/hooks/useSendDDExperiments';
import BrowserCookies from '~/utilities/BrowserCookies';
import { useFilteredByMinDown } from './hooks/conditionalTiles';
import { useTrackResults } from './hooks/events';

function useFullStoryUserVars() {
  useEffect(() => {
    window.FS?.setUserVars({
      browserCookieId: BrowserCookies.get('BrowserCookieId'),
      searchVersion: process.env.APP_VERSION
    });
  }, []);
}

type OwnProps = {
  fetchedInventoryOnServer?: boolean;
};

function SearchData(props: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  useResizeListener();
  useFullStoryUserVars();
  useGetInventory(props.fetchedInventoryOnServer);
  useGetAvailability();
  useGetPricing();
  useGetUserProfile();
  useNavigation();
  useScrollToTop();
  useSetCvnaId();
  useSetPageNumber();
  useShowFinance();
  useToggleAppliedTradeCookie();
  useTrackClickEvents(trackEvent);
  useTrackResults();
  useSendDDExperiments();
  useGetLowInventoryAvailability();
  useLogZipCodeChanges();
  useFilteredByMinDown();

  return null;
}

export default SearchData;
